import React from 'react';
import { Box, HStack, IconButton } from '@chakra-ui/react';
import { AiFillCheckCircle, AiFillDelete, AiOutlineEye } from 'react-icons/ai';
import { User } from '../../../../types/user';
import UsernameFormatted from '../../../../components/UsernameFormatted';
import AdminTableUser from '../../AdminTableUser';
import { formatUri } from '../../../../utils/api/helpers';
import { ADMIN_PROFILE_UPDATE_PATH, PROFILE_PATH } from '../../../../routing/constants';
import { useNavigate } from 'react-router-dom';
import { FaRegEdit } from 'react-icons/fa';

interface UserAminCardProps {
  user: User;
  onValidate: () => void;
  onDelete: () => void;
}

const UserAminCard: React.FC<UserAminCardProps> = ({ user, onValidate, onDelete }) => {
  const navigate = useNavigate();
  const handleOpenNewTab = () => {
    window.open(formatUri({ username: user.username }, PROFILE_PATH), '_blank');
  };
  return (
    <Box borderWidth="1px" borderRadius="lg" p={4} m={2} height="100%">
      <HStack justifyContent="space-between">
        <UsernameFormatted user={user} styles={{ fontSize: 'xl', textAlign: 'center' }} />
        <HStack>
          <IconButton aria-label="Edit" icon={<FaRegEdit />} onClick={() => navigate(formatUri({ username: user.username }, ADMIN_PROFILE_UPDATE_PATH))} />
          <IconButton aria-label="Show" icon={<AiOutlineEye />} onClick={handleOpenNewTab} />
          <IconButton aria-label="Valider" icon={<AiFillCheckCircle />} onClick={onValidate} />
          <IconButton aria-label="Supprimer" icon={<AiFillDelete />} onClick={onDelete} />
        </HStack>
      </HStack>
      <AdminTableUser user={user} />
    </Box>
  );
};

export default UserAminCard;
